import type { CSSProperties, ReactNode } from 'react';
import type {
  IconDefinition,
  SizeProp,
} from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Space, theme, Typography } from 'antd';
import type { TitleProps } from 'antd/es/typography/Title';

interface HeaderIconProps {
  color?: string;
  size?: SizeProp;
}
export interface PosModalHeaderProps {
  eyebrowLabel?: string;
  icon?: IconDefinition;
  iconProps?: HeaderIconProps;
  title?: ReactNode;
  titleSize?: TitleProps['level'];
  children?: ReactNode;
  hasTabs?: boolean;
  hasTitleBorder?: boolean;
  style?: CSSProperties;
}

export const PosModalHeader = ({
  eyebrowLabel,
  icon,
  title,
  titleSize = 4,
  iconProps,
  children,
  hasTabs,
  hasTitleBorder,
  style,
}: PosModalHeaderProps) => {
  const { token } = theme.useToken();

  return (
    <Space
      direction={'vertical'}
      size={20}
      style={{
        fontWeight: 'bold',
      }}
    >
      {eyebrowLabel && (
        <Typography.Title level={5} style={{ marginBottom: 0 }}>
          {eyebrowLabel}
        </Typography.Title>
      )}

      <Flex
        style={{
          width: '100%',
          ...(!hasTabs && { marginBottom: token.marginMD }),
          ...style,
        }}
        align="flex-start"
        justify="space-between"
        wrap="wrap"
        gap="middle"
        className={hasTitleBorder ? 'pos-modal-header-border' : ''}
      >
        <Flex gap="small" align="center" wrap="wrap">
          <Typography.Title level={titleSize} style={{ marginBottom: 0 }}>
            {icon && (
              <FontAwesomeIcon
                icon={icon}
                size={iconProps?.size}
                color={iconProps?.color ?? token.Card?.extraColor}
                style={{ marginRight: token.marginXS }}
              />
            )}
            {title}
          </Typography.Title>
          {children}
        </Flex>
      </Flex>
    </Space>
  );
};
